
import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, Form, Spin, Select } from 'antd';
import { FaRegTrashAlt, FaEdit } from 'react-icons/fa';
import { PlusOutlined } from '@ant-design/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import ValoresInput from '../ValoresInput';
import formatarValor from '../formatarValor';


const { Option } = Select;

const Cambio = () => {
  const [cambios, setCambios] = useState([]);
  const [moedas, setMoedas] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [selectedCambio, setSelectedCambio] = useState(null);
  const [cambioToDelete, setCambioToDelete] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const total = filteredData.length;
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, total);

  useEffect(() => {
    document.title = 'Câmbios';
    fetchCambios();
    fetchMoedas();
  }, []);

  const sms_error = msg => toast.error(msg);
  const sms_success = msg => toast.success(msg);

  const fetchCambios = async () => {
    setLoading(true);
    try {
      const response = await Api.ListCambio();
      const dados = Array.isArray(response) ? response : [];
      const formatado = dados.map(item => ({
        key: item.id,
        id_moeda: item.id_moeda,
        valor:    formatarValor( item.valor) ,
        moeda_descricao: item.moeda_descricao || ''
      }));
      setCambios(formatado);
      setFilteredData(formatado);
    } catch (error) {
      sms_error('Erro ao buscar câmbios: ' + (error.message || 'Erro desconhecido'));
    } finally {
      setLoading(false);
    }
  };

  const fetchMoedas = async () => {
    try {
      const response = await Api.ListMoedaCambio();
      setMoedas(Array.isArray(response) ? response : []);
    } catch (error) {
      sms_error('Erro ao buscar moedas.');
    }
  };

  const handleSearch = value => {
    setSearchText(value);
    setCurrentPage(1);
    const search = value.toLowerCase();
    const filtered = cambios.filter(item =>
      item.moeda_descricao.toLowerCase().includes(search)
    );
    setFilteredData(filtered);
  };

  const handleAdd = async values => {
    setAddLoading(true);
    try {


      const result = await Api.AddCambio({
        id_moeda: values.id_moeda,
        valor: values.valor.replace(/\s/g, '')
      });
      if (result.success) {
        sms_success('Câmbio adicionado com sucesso!');
        setIsAddModalVisible(false);
        form.resetFields();
        await fetchCambios();
      } else {
        sms_error(result.message || 'Erro ao adicionar câmbio');
      }
    } catch (error) {
      sms_error('Erro ao adicionar câmbio: ' + error.message);
    } finally {
      setAddLoading(false);
    }
  };

  const handleEdit = async values => {
    setEditLoading(true);
    try {

 
      const result = await Api.AlterCambio({
        id: selectedCambio.key,
        id_moeda: values.id_moeda,
        valor:  values.valor.replace(/\s/g, '')
      });
      if (result.success) {
        sms_success('Câmbio editado com sucesso!');
        setIsEditModalVisible(false);
        editForm.resetFields();
        await fetchCambios();
      } else {
        sms_error(result.message || 'Erro ao editar câmbio');
      }
    } catch (error) {
      sms_error('Erro ao editar câmbio: ' + error.message);
    } finally {
      setEditLoading(false);
    }
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      const result = await Api.DeleteCambio({ id: cambioToDelete });
      if (result.success) {
        sms_success('Câmbio excluído com sucesso!');
        await fetchCambios();
      } else {
        sms_error(result.message || 'Erro ao excluir câmbio');
      }
    } catch (error) {
      sms_error('Erro ao excluir câmbio: ' + error.message);
    } finally {
      setDeleteLoading(false);
      setIsDeleteModalVisible(false);
    }
  };

  const columns = [
    {
      title: 'Moeda',
      dataIndex: 'moeda_descricao',
      key: 'moeda_descricao',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
         
            placeholder="Pesquisar moeda"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => {
              confirm();
              handleSearch(selectedKeys[0]);
            }}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => {
              confirm();
              handleSearch(selectedKeys[0]);
            }}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Filtrar
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              handleSearch('');
            }}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        record.moeda_descricao.toLowerCase().includes(value.toLowerCase())
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor'
    },
    {
      title: 'Ações',
      key: 'acoes',
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 10 }}>
          <FaEdit
            style={{ cursor: 'pointer', color: '#1890ff' }}
            onClick={() => {
              setSelectedCambio(record);
              editForm.setFieldsValue(record);
              setIsEditModalVisible(true);
            }}
          />
          <FaRegTrashAlt
            style={{ cursor: 'pointer', color: '#ff4d4f' }}
            onClick={() => {
              setCambioToDelete(record.key);
              setIsDeleteModalVisible(true);
            }}
          />
        </div>
      )
    }
  ];

  return (
    <div>
      <ToastContainer />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsAddModalVisible(true)}
        >
          Adicionar
        </Button>
      </div>

      <Spin spinning={loading} tip="Carregando...">
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: filteredData.length,
            onChange: (page, size) => {
              setCurrentPage(page);
              setPageSize(size);
            },
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50']
          }}
          scroll={{ x: 'max-content' }}
        />
      </Spin>

      <div style={{ marginBottom: 10 }}>
        <strong>
          {total > 0
            ? `Mostrando ${startIndex}–${endIndex} de ${total} câmbios`
            : 'Nenhum câmbio encontrado'}
        </strong>
      </div>

      <Modal
        title="Adicionar Câmbio"
        visible={isAddModalVisible}
        onCancel={() => {
          form.resetFields();
          setIsAddModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleAdd}>
          <Form.Item name="id_moeda" label="Moeda" rules={[{ required: true, message: 'Moeda é obrigatória' }]}>
            <Select placeholder="Selecione a moeda">
              {moedas.map(m => (
                <Option key={m.id} value={m.id}>{m.descricao}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="valor" label="Valor" rules={[{ required: true, message: 'Valor é obrigatório' }]}>


            <ValoresInput/>
          </Form.Item>
          
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={() => { form.resetFields(); setIsAddModalVisible(false); }} style={{ marginRight: 8 }}>
                Cancelar
              </Button>
              <Button type="primary" htmlType="submit" loading={addLoading}>
                Salvar
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Editar Câmbio"
        visible={isEditModalVisible}
        onCancel={() => {
          editForm.resetFields();
          setIsEditModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={editForm} layout="vertical" onFinish={handleEdit}>
          <Form.Item name="id_moeda" label="Moeda" rules={[{ required: true , message: 'Moeda é obrigatória'}]}>
            <Select placeholder="Selecione a moeda">
              {moedas.map(m => (
                <Option key={m.id} value={m.id}>{m.descricao}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="valor" label="Valor" rules={[{ required: true, message: 'Valor é obrigatório'  }]}>
             <ValoresInput/>
          </Form.Item>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={() => { editForm.resetFields(); setIsEditModalVisible(false); }} style={{ marginRight: 8 }}>
                Cancelar
              </Button>
              <Button type="primary" htmlType="submit" loading={editLoading}>
                Salvar
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Confirmar Exclusão"
        visible={isDeleteModalVisible}
        onOk={handleDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText="Sim"
        cancelText="Não"
        confirmLoading={deleteLoading}
      >
        <p>Tem certeza que deseja excluir este câmbio?</p>
      </Modal>
    </div>
  );
};

export default Cambio;
